const all = ["terms"] as const;
const lists = () => [...all, "list"] as const;

export const termsKeys = {
  all,
  lists,
  orgList: (filters?: any) => [...lists(), "orgs", ...(filters ? [filters] : [])] as const,
  termsList: (filters?: any) => [...lists(), "versions", ...(filters ? [filters] : [])] as const,
  termsStatus: () => [...all, "status"] as const,
  termsHistory: (filters?: any) => [...all, "history", ...(filters ? [filters] : [])] as const,
};